import { render, staticRenderFns } from "./ReviewTagsPreview.vue?vue&type=template&id=0ab3989e&scoped=true&"
import script from "./ReviewTagsPreview.vue?vue&type=script&lang=js&"
export * from "./ReviewTagsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTagsPreview.vue?vue&type=style&index=0&id=0ab3989e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab3989e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
